import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'graphicsType';

export class GraphicsType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
